module.exports = __webpack_public_path__ + "static/media/heringsLOGO_white.22a449e2.svg";